import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles'
import { irem, rem } from '../../utils'

export const StyledFeaturesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${irem(10)};

  ${props => props.theme.breakpoints.up('sm')} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${props => props.theme.typography.pxToRem(28)};
    grid-row-gap: ${props => props.theme.typography.pxToRem(26)};
    margin: 0;
  }
`

export const StyledFeaturesListItemWrapper = styled.div`
  background: ${props => props.theme.custom.colors.orange};
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  column-gap: ${props => props.theme.typography.pxToRem(18)};
  padding: ${irem(18)};
  border-radius: ${irem(10)};

  ${props => props.theme.breakpoints.up('sm')} {
    flex-direction: column;
    height: 100%;
  }

  ${props => props.theme.breakpoints.up('md')} {
    padding: ${irem(30)};
  }
`

export const StyledFeaturesListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${irem(5)};
`

export const StyledCreditUnionIconContainer = styled.div`
  display: inherit;
  margin-top: ${irem(5)};
  min-width: ${props => rem(40, props.theme)};
  max-width: ${props => rem(40, props.theme)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: 0;
  }

  img {
    max-width: 100%;
  }
`

export const StyledTitleContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.typography.pxToRem(5)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-top: ${props => props.theme.typography.pxToRem(20)};
  }
`

export const StyledTitle = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(18)};
  font-weight: 600;
  color: ${props => props.theme.custom.colors.darkRed};
    
  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(20)};
  }
`

export const StyledAsterisk = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(20)};
  color: ${props => props.theme.palette.primary.main};
  font-weight: 500;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(15)};
  }
`

export const StyledDescriptionContainer = styled.div`
  ${props => props.theme.breakpoints.up('sm')} {
    padding-top: ${props => props.theme.typography.pxToRem(10)};
  }
`

export const StyledDescription = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  line-height: ${props => props.theme.typography.pxToRem(22)};

  > a {
    font-size: ${props => props.theme.typography.pxToRem(14)};

    ${props => props.theme.breakpoints.up('sm')} {
      font-size: ${props => props.theme.typography.pxToRem(15)};
    }
  }
`